<template>
  <b-modal
    v-model="show"
    :title="$t('Your organization has moved to the new MyISA')"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    centered
  >
    <p class="mb-3">
      {{ $t('{org} is now hosted on the new MyISA. This version no longer receives your data.', { org: currentOrganization }) }}
    </p>
    <p class="mb-4">
      {{ $t('Please sign in on {host} to keep monitoring your care units.', { host: newAppHost }) }}
      {{ $t('For more information, contact us at ') }}<a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.
    </p>
    <a :href="newAppUrl" class="btn btn-primary btn-block btn-rounded">{{ $t('Go to the new MyISA') }}</a>
  </b-modal>
</template>

<script>
import MIGRATION from '@/constants/migration';

export default {
  data() {
    return {
      newAppUrl: MIGRATION.newAppUrl,
      newAppHost: MIGRATION.newAppHost,
      supportEmail: MIGRATION.supportEmail,
    };
  },
  computed: {
    currentOrganization() {
      return this.$store.state.fleet.currentOrganization;
    },
    // Mirrors IsOpenApiMigrated on the ISACore side: the organization counts as
    // migrated as soon as one of its roomsets carries isReadyForMigration.
    isOrganizationMigrated() {
      const roomsetList = this.$store.state.fleet.roomsetList;
      if (!roomsetList || !roomsetList.length || !this.currentOrganization) return false;
      return roomsetList.some(rs => rs.organizationLabel === this.currentOrganization && rs.isReadyForMigration === true);
    },
    show: {
      get() {
        return this.isOrganizationMigrated;
      },
      // The modal is blocking on purpose, but b-modal still needs a setter.
      set() {},
    },
  },
};
</script>
